<template>
    <BaseAvatar :size="size" :initials="initials">
        <template v-if="!initials" #default><i class="bi bi-person" aria-hidden="true" /></template>
    </BaseAvatar>
</template>

<script setup lang="ts">
import BaseAvatar, { type BaseAvatarSize } from "~vue/components/BaseAvatar.vue";
import { getAvatarInitials } from "~vue/utils/avatarUtils";
import { computed } from "vue";

const { name, email, size = "sm" } = defineProps<{ name?: string | null; email?: string | null; size?: BaseAvatarSize }>();

const initials = computed(() => getAvatarInitials(name) || (email ?? "").trim().slice(0, 2).toUpperCase());
</script>
